export const stats = [
  { value: '+600', label: 'Fertige Sequenzen & Karten' },
  { value: '+1.500', label: 'Zufriedene Lehrer' },
  { value: '4.200+', label: 'Gesparte Planungsstunden' },
  { value: '98%', label: 'Weiterempfehlungsrate' },
]

export const differenceStats = [
  { value: '+600', label: 'Fertige Sequenzen & Karten (Basis bis Meisterschaft)' },
  { value: '6', label: 'Komplette digitale Bände' },
  { value: '100%', label: 'Sofort-Download' },
]

export const beforeItems = [
  'Stundenlanges Planen jeder einzelnen Stunde von Null auf, Suchen auf verschiedenen Websites und Social Media',
  'Erklärungsnot: Nicht wissen, wie man komplexe Konzepte oder Ausrichtungen einfach erklärt',
  'Keine klare Verbindung zwischen physischer Praxis, Philosophie und Anatomie',
  'Schwierigkeiten beim Erstellen von Varianten für verschiedene Level oder Einschränkungen',
]

export const afterItems = [
  '5 Minuten Durchsicht und du bist bereit, mit voller Sicherheit in den Unterricht zu gehen',
  'Fließende, inspirierende Sequenzen mit integrierten hochauflösenden Grafiken',
  'Quiz, Tests und Bewertungsschemata zu 100% fertig, um Fortschritte zu messen',
  'Schüler, die wirklich verstehen – dank Infografiken und Konzept-Maps',
]

export const packItems = [
  {
    emoji: '📚',
    title: '6 Bände basierend auf dem Unterrichtsjahr',
    text: 'Von der Entdeckung der Sinne bis zu fortgeschrittenen Inversionen und Meisterschaft',
  },
  {
    emoji: '🧘‍♀️',
    title: '«Ready-to-use» Unterrichts-Scripts',
    text: 'Didaktische Cues, die dir genau sagen, was du während der Stunde sagen kannst',
  },
  {
    emoji: '📐',
    title: 'Visuelles Yoga: Infografiken & Maps',
    text: '8K-Grafiken, die unsichtbare Prozesse verständlich machen: Energiefluss, Anatomie und Ausrichtung',
  },
  {
    emoji: '📊',
    title: 'Tests, Lösungen & Inklusions-Support',
    text: 'Werkzeuge für einen wirklich inklusiven Unterricht für alle Schülertypen',
  },
  {
    emoji: '🔑',
    title: 'Answer Keys (Lösungsschlüssel)',
    text: 'Komplette Lösungen für stressfreie und sofortige Korrekturen',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/5h6H4SeFAHpsi8HP7PUV2x/Captura_de_pantalla_2026-09-06_a_las_9.43.45_p.webp',
    level: 'Grundlagen · Sequenz',
    title: 'Kompletter Flow',
    caption:
      'Die 9 Schritte des Sonnengrußes mit Atem-Anleitung Schritt für Schritt und einer Notiz dazu, wie du den Flow führst, ohne die Übergänge zu hetzen.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3yzw5Xt93bRJG69hQi3DPP/Captura_de_pantalla_2026-09-06_a_las_9.44.56_p.webp',
    level: 'Einheit 2 · Woche 3-4',
    title: 'Intermediate Vinyasa: dynamische Übergänge',
    caption:
      'Neun Asanas mit Intention und Nutzen jeder einzelnen, die zwei neuen Elemente hervorgehoben und der komplette Rückweg nach Tadasana.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aiS6oZXAuyS415iUVKBJJg/Captura_de_pantalla_2026-09-06_a_las_9.45.58_p.webp',
    level: 'Meisterschaft · Tracker',
    title: 'Arm Balance Progression (6 Wochen)',
    caption:
      '6-Wochen-Tracker zum Ausfüllen mit Bewertungsskala von «nicht bereit» bis «Meisterschaft» für vier Armbalancen.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ovveFqdEnWCqWGazjHVUoF/Captura_de_pantalla_2026-09-06_a_las_9.47.07_p.webp',
    level: 'Sicherheit · Technikkarte',
    title: 'Sichere Hilfestellungen',
    caption:
      'Drei manuelle Adjustments erklärt mit Handpositionierung, verbaler Kommunikation und den Grenzen, die nie überschritten werden dürfen.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4WTo6wUVHQP777a8Lxgu9Q/Captura_de_pantalla_2026-09-06_a_las_9.52.19_p.webp',
    level: 'Inklusivität · Varianten',
    title: 'Nutze die Haltung, um in den Körper zu kommen',
    caption:
      'Vier Varianten der Taube (Pigeon Pose) je nach Hüftstruktur und Einschränkungen, mit Hilfsmitteln und liegenden Alternativen.',
  },
]

export const bonuses = [
  {
    title: '5-MINUTEN KLASSENSTART-CHECKLIST',
    was: '€10',
    text: 'Das System für einen perfekten Start: Alles, was du tun musst, bevor der erste Schüler den Raum betritt',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4ef6d544-f994-4bd5-ae84-326b351759fc.jpg',
  },
  {
    title: '120 YOGA-CUES FÜR PROFESSIONELLE LEHRER',
    was: '€12',
    text: 'Präzise Anleitung: Die richtigen Worte für Ausrichtung, Atem und Fokus, um deine Schüler sicher zu führen',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/5038d695-efad-4c34-8747-4d7b7b5b336a.jpg',
  },
  {
    title: 'ASANA-VARIATIONEN NOTFALL-KARTEN',
    was: '€10',
    text: 'Sei auf alles vorbereitet: Schnelle visuelle Lösungen für Schüler mit Einschränkungen oder unterschiedlichen Levels',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/1f83d082-391a-448a-80b2-b5c7169c1bc9.jpg',
  },
  {
    title: 'SCHÜLER-LEVEL EINSCHÄTZUNGSBOGEN',
    was: '€10',
    text: 'Professionalisiere deine Didaktik: Ein fertiges System, um den Fortschritt deiner Schüler objektiv zu bewerten',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4e01cb92-d3cf-4812-8e04-c46003b41596.jpg',
  },
  {
    title: '30/45/60/75-MINUTEN KLASSENMAPS',
    was: '€10',
    text: 'Absolute zeitliche Flexibilität: Passe jede Sequenz perfekt an den vorgegebenen Zeitrahmen an',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/bf108997-0ede-40ca-80f9-78564c5f4771.jpg',
  },
]

export const offerRows = [
  { label: 'YOGA BEREIT™ Pack (6 Digitale Bände)', value: '€77' },
  { label: '5 Strategische Exklusiv-Boni', value: '€52' },
]

export const testimonials = [
  {
    quote:
      'Ich habe endlich meine Abende zurück. Meine Schüler lieben die neuen visuellen Karten.',
    name: 'Chiara M.',
    location: 'Berlin 🇩🇪',
  },
  {
    quote:
      'Professionelles Material, sofort einsatzbereit. Die Voice-Scripts haben mir unglaubliche Sicherheit gegeben.',
    name: 'Lukas B.',
    location: 'München 🇩🇪',
  },
  {
    quote:
      'Von den Grundlagen bis zu fortgeschrittenen Klassen – die einzige Investition, die eine Yogalehrerin braucht.',
    name: 'Elena V.',
    location: 'Wien 🇦🇹',
  },
]

export const faqs = [
  {
    q: 'Wie erhalte ich das Material?',
    a: 'Sofortiger Download-Link per E-Mail direkt nach dem Kauf.',
  },
  {
    q: 'Funktioniert es für alle Level?',
    a: 'Ja, von absoluten Anfängern bis zur Meisterschaft.',
  },
  {
    q: 'Gibt es monatliche Kosten?',
    a: 'Nein, nur eine Einmalzahlung.',
  },
]
